export default {
    "molwt": {
        visible: true,
        categoryId: 0,
        endpointId: 0,
        category: 'properties_free',
        endpoint: 'molwt',
        categoryName: 'Physicochemical(Free)',
        endpointName: 'Molecular weight',
        endpointNameHtml: 'Molecular weight',
        unitName: 'g/mol',
        unitNameHtml: 'g/mol',
        required: true,
        analysis: false,
        width: 130,
        type: 'number'
    },
    "hdonors": {
        visible: true,
        categoryId: 0,
        endpointId: 1,
        category: 'properties_free',
        endpoint: 'hdonors',
        categoryName: 'Properties (Free)',
        endpointName: 'H-bond donors',
        endpointNameHtml: 'H-bond donors',
        unitName: '---',
        unitNameHtml: '---',
        required: true,
        analysis: false,
        width: 110,
        type: 'number'
    },
    "hacceptors": {
        visible: true,
        categoryId: 0,
        endpointId: 2,
        category: 'properties_free',
        endpoint: 'hacceptors',
        categoryName: 'Properties (Free)',
        endpointName: 'H-bond acceptors',
        endpointNameHtml: 'H-bond acceptors',
        unitName: '---',
        unitNameHtml: '---',
        required: true,
        analysis: false,
        width: 140,
        type: 'number'
    },
    "logp": {
        property: true,
        visible: true,
        categoryId: 0,
        endpointId: 3,
        category: 'properties',
        endpoint: 'logp',
        categoryName: 'Physicochemical',
        endpointName: 'logP(Wildman-Crippen)',
        endpointNameHtml: 'logP<small>(Wildman-Crippen)</small>',
        unitName: '',
        unitNameHtml: '',
        required: false,
        analysis: false,
        width: 210,
        type: 'number'
    },
    "water_solubility": {
        categoryId: 1,
        endpointId: 0,
        category: 'properties',
        endpoint: 'water_solubility',
        categoryName: 'Properties',
        endpointName: 'Water solubility',
        endpointNameHtml: 'Water solubility',
        unitName: 'log(mol/L) at 25 °C, pH 7.0',
        unitNameHtml: 'log(mol/L) <br>at 25 °C, pH 7.0',
        required: false,
        analysis: false,
        width: 210,
        type: 'number'
    },
    "pka": {
        categoryId: 1,
        endpointId: 1,
        category: 'properties',
        children: 'anb',
        endpoint: 'pka',
        categoryName: 'Properties',
        endpointName: 'pKa',
        endpointNameHtml: 'pKa',
        unitName: '---',
        unitNameHtml: '---',
        required: false,
        analysis: false,
        width: 120,
        type: 'number'
    },
    "logp_v": {
        property: true,
        visible: true,
        categoryId: 1,
        endpointId: 2,
        category: 'properties',
        endpoint: 'logp_v',
        categoryName: 'Physicochemical',
        endpointName: 'logP(VIRTUALMAN)',
        endpointNameHtml: 'logP<small>(VIRTUALMAN)</small>',
        unitName: '',
        unitNameHtml: '',
        required: false,
        analysis: false,
        width: 210,
        type: 'number'
    },
    "clearance": {
        categoryId: 2,
        endpointId: 0,
        category: 'pk',
        chart: 'iv',
        endpoint: 'clearance',
        categoryName: 'PK',
        endpointName: 'Clearance',
        endpointNameHtml: 'Clearance',
        unitName: 'mL/min/kg',
        unitNameHtml: 'mL/min/kg',
        required: false,
        analysis: false,
        width: 110,
        type: 'number'
    },
    "vod": {
        categoryId: 2,
        endpointId: 1,
        category: 'pk',
        chart: 'iv',
        endpoint: 'vod',
        categoryName: 'PK',
        endpointName: 'Volume of Distribution',
        endpointNameHtml: 'Volume of Distribution',
        unitName: 'L/kg',
        unitNameHtml: 'L/kg',
        required: false,
        analysis: false,
        width: 110,
        type: 'number'
    },
    "halflife": {
        categoryId: 2,
        endpointId: 2,
        category: 'pk',
        chart: 'iv',
        endpoint: 'halflife',
        categoryName: 'PK',
        endpointName: 'Half-life',
        endpointNameHtml: 'Half-life',
        unitName: 'hr',
        unitNameHtml: 'hr',
        required: false,
        analysis: false,
        width: 110,
        type: 'number'
    },
    "caco2": {
        categoryId: 3,
        endpointId: 0,
        category: 'absorption',
        endpoint: 'caco2',
        categoryName: 'Absorption',
        endpointName: 'Caco-2 Permeability',
        endpointNameHtml: 'Caco-2 Permeability',
        unitName: 'log(cm/sec)',
        unitNameHtml: 'log(cm/sec)',
        required: false,
        analysis: false,
        width: 110,
        type: 'number'
    },
    "bbb_c": {
        categoryId: 3,
        endpointId: 1,
        category: 'absorption',
        endpoint: 'bbb_c',
        categoryName: 'Absorption',
        endpointName: 'Blood-brain barrier',
        endpointNameHtml: 'Blood-brain barrier',
        unitName: '---',
        unitNameHtml: '---',
        required: false,
        analysis: false,
        width: 110,
        type: 'boolean'
    },
    "pgpinhibitor": {
        categoryId: 3,
        endpointId: 2,
        analysis: false,
        category: "absorption",
        categoryName: "Absorption",
        endpoint: "pgpinhibitor",
        endpointName: "P-gp inhibitor",
        endpointNameHtml: "P-gp inhibitor",
        nofree: true,
        required: false,
        type: "boolean",
        unitName: "---",
        unitNameHtml: "---",
        width: 110
    },
    "livermicrosom": {
        categoryId: 4,
        endpointId: 0,
        category: 'metabolism',
        endpoint: 'livermicrosom',
        categoryName: 'Metabolism',
        endpointName: 'Liver microsomal stability',
        endpointNameHtml: 'Liver microsomal<br>stability',
        unitName: 'hr',
        unitNameHtml: 'hr',
        required: false,
        analysis: false,
        width: 160,
        type: 'number'
    },
    "hps": {
        categoryId: 4,
        endpointId: 1,
        analysis: false,
        category: "metabolism",
        categoryName: "Metabolism",
        endpoint: "hps",
        endpointName: "Human Blood/Plasma Stability",
        endpointNameHtml: "Human Blood/<br>Plasma Stability",
        nofree: true,
        required: false,
        type: "number",
        unitName: "min",
        unitNameHtml: "min",
        width: 160
    },
    "1a2inhibitor": {
        categoryId: 5,
        endpointId: 0,
        category: 'cyp',
        endpoint: '1a2inhibitor',
        categoryName: 'CYP',
        endpointName: '1A2 inhibitor',
        endpointNameHtml: '1A2 inhibitor',
        unitName: '---',
        unitNameHtml: '---',
        required: false,
        analysis: false,
        width: 110,
        type: 'boolean'
    },
    "2c9inhibitor": {
        categoryId: 5,
        endpointId: 1,
        category: 'cyp',
        endpoint: '2c9inhibitor',
        categoryName: 'CYP',
        endpointName: '2C9 inhibitor',
        endpointNameHtml: '2C9 inhibitor',
        unitName: '---',
        unitNameHtml: '---',
        required: false,
        analysis: false,
        width: 110,
        type: 'boolean'
    },
    "2c19inhibitor": {
        categoryId: 5,
        endpointId: 2,
        category: 'cyp',
        endpoint: '2c19inhibitor',
        categoryName: 'CYP',
        endpointName: '2C19 inhibitor',
        endpointNameHtml: '2C19 inhibitor',
        unitName: '---',
        unitNameHtml: '---',
        required: false,
        analysis: false,
        width: 110,
        type: 'boolean'
    },
    "2d6inhibitor": {
        categoryId: 5,
        endpointId: 3,
        category: 'cyp',
        endpoint: '2d6inhibitor',
        categoryName: 'CYP',
        endpointName: '2D6 inhibitor',
        endpointNameHtml: '2D6 inhibitor',
        unitName: '---',
        unitNameHtml: '---',
        required: false,
        analysis: false,
        width: 110,
        type: 'boolean'
    },
    "3a4inhibitor": {
        categoryId: 5,
        endpointId: 4,
        category: 'cyp',
        endpoint: '3a4inhibitor',
        categoryName: 'CYP',
        endpointName: '3A4 inhibitor',
        endpointNameHtml: '3A4 inhibitor',
        unitName: '---',
        unitNameHtml: '---',
        required: false,
        analysis: false,
        width: 110,
        type: 'boolean'
    },
    "mutagenicity": {
        visible: true,
        categoryId: 6,
        endpointId: 0,
        category: 'tox',
        endpoint: 'mutagenicity',
        categoryName: 'Tox',
        endpointName: 'Mutagenicity',
        endpointNameHtml: 'Mutagenicity',
        unitName: '---',
        unitNameHtml: '---',
        required: false,
        analysis: true,
        width: 110,
        type: 'boolean'
    },
    "herg": {
        categoryId: 6,
        endpointId: 1,
        category: 'tox',
        endpoint: 'herg',
        categoryName: 'Toxicity',
        endpointName:
            'hERG affinity pIC\u2085\u2080 with cut off 4.39(IC\u2085\u2080 40\u00B5M)',
        endpointNameHtml:
            'hERG affinity pIC\u2085\u2080 <br>with cut off 4.39(IC\u2085\u2080 40\u00B5M)',
        unitName: '---',
        unitNameHtml: '---',
        required: false,
        mark: true,
        analysis: true,
        width: 200,
        type: 'boolean'
    },
    "hepatotoxicity": {
        categoryId: 6,
        endpointId: 2,
        analysis: true,
        category: "tox",
        categoryName: "Toxicity",
        endpoint: "hepatotoxicity",
        endpointName: "Hepatotoxicity",
        endpointNameHtml: "Hepatotoxicity",
        nofree: true,
        required: false,
        type: "boolean",
        unitName: "---",
        unitNameHtml: "---",
        width: 110
    },
    "cytotoxicity": {
        categoryId: 6,
        endpointId: 3,
        analysis: true,
        category: "tox",
        categoryName: "Toxicity",
        endpoint: "cytotoxicity",
        endpointName: "Cytotoxicity",
        endpointNameHtml: "Cytotoxicity",
        nofree: true,
        required: false,
        type: "boolean",
        unitName: "---",
        unitNameHtml: "---",
        width: 110
    }
};
